import React from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import FilledButton from "../../Components/Button/FilledButton";
import Typography from "@mui/material/Typography";

function EditCategoryModal(props) {
    const { open, handleClose, editCategoryName, setEditCategoryName, handleConfirmEditCategory, type } = props;
    return (
        <Modal
            open={open}
            onClose={handleClose}
            BackdropProps={{ style: { opacity: "60%" } }}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            className="mark-as-complete-modal-main"
        >
            <Box className="mark-as-complete-modal" sx={{ minHeight: "201px !important", top: "40% !important" }}>
                <Grid container>
                    <Grid item xs={12}>
                        <CloseIcon
                            id="close_edit_cat_modal"
                            sx={{ float: "right", cursor: "pointer", color: "#A5A5A5", mt: 1, mr: 1, }}
                            onClick={handleClose}
                        />
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        sx={{ textAlign: "left", marginBottom: "20px", marginLeft: "15px", }}
                    >
                        {type === "template" ? <Typography className="modal-heading-template">Rename Template</Typography> : <p className="modal-heading">{`Edit ${type === "line" ? "line" : "category"} name`} </p>}
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <FormControl variant="standard" className="forms-control" style={{ paddingLeft: "15px" }}>
                            <label className="input-form-label" htmlFor="CategoryName">
                                {type === "template" ? "Template Name" : `${type === "line" ? "Line" : "Category"} Name`}
                            </label>
                            <TextField
                                id={type === "template" ? "template_name" : "category_name"}
                                className="input-textfield"
                                size="small"
                                variant="outlined"
                                placeholder={type === "template" ? "Template name" : "Category name"}
                                type="text"
                                value={editCategoryName}
                                onChange={(e) => setEditCategoryName(e.target.value)}
                                style={{ width: "97%" }}
                            />
                        </FormControl>
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        sx={{ display: "flex", textAlign: "center", mt: "14px", mb: "30px", justifyContent: "center", gap: "20px", }}
                    >
                        <FilledButton width="95%" text="Save" onClick={() => handleConfirmEditCategory(editCategoryName, type)} id="confirm_edit_cat_button" />
                    </Grid>
                </Grid>
            </Box>
        </Modal>
    )
}

export default EditCategoryModal;